import { apiClient } from "@/lib/api/client";
import { getDataOrThrowApiError } from "@/lib/api/error";

import { WORKERS_FOR_SELECT_PATH } from "./key";
import type { Category } from "./type";

export const getWorkersForSelect = async (
  searchText: string,
  page: number,
  category?: Category,
) => {
  const res = await apiClient.GET(WORKERS_FOR_SELECT_PATH, {
    params: { query: { freeText: searchText, page, category } },
  });
  return getDataOrThrowApiError(res);
};
